import { call, put, takeLatest, all, cancelled } from "redux-saga/effects"
import axios from "axios"
import { flatMap, uniq,isEmpty } from "lodash"
import { generateTree } from "../../../utils/utils"
import {
  GET_DRILLDOWN_DIVISIONS_WATCHER,
  GET_DIMENSIONS_WATCHER,
  GRAPHIC_BARS_WATCHER,
  DIVISION_WITH_ENGAGEMENT_WATCHER,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_MEASURE_WATCHER,
} from "./constants"

import {
  getDivisionsSuccess,
  getDivisionsFailed,
  getDimensionsSuccess,
  graphicBarsSuccess,
  getDivisionMeasureRangeColorSuccess,
  getDivisionWithEngagementSuccess,
  getMeasureSuccess,
} from "./actions"
import { LOCAL_TOKEN } from "../../../utils/storage"

function getDivisionsApi(params) {
  const excludeparam = params.isExclude ? "&exclude=true" : "&exclude=false"
  let url = `reports/measure/${params.measure}/divisions?f${excludeparam}`
  if (params.isEngagement) {
    if (params.selectedType == "Engagement") {
      if (!params.dimension && (params.search == "" || params.search != "")) {
        url = `reports/measure/${params.measure}/divisions/engagement?f${excludeparam}`
      }
      if (params.dimension) {
        url = `reports/measure/${params.measure}/dimensions/${params.dimension}/divisions?f${excludeparam}`
      }
    } else if (params.dimension) {
      url = `reports/measure/${params.measure}/dimensions/${params.dimension}/divisions?f${excludeparam}`
    }
  } else if (params.dimension) {
    url = `reports/measure/${params.measure}/dimensions/${params.dimension}/divisions?f${excludeparam}`
  }

  // Search by word
  if (params.search != "") {
    url = `${url}&filter[searchByName]=${
      typeof params.search === "undefined" ? "" : params.search
    }`
  }
  if (params.level) {
    url = `${url}&filter[level]=${params.level}`
  }

  // Making api call
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: params.params,
  })
}

export function* getDivisionsSaga(params) {
  try {
    const { data } = yield call(getDivisionsApi, params.payload)

    const result = {
      data: data.data,
      data_drilldown:
        data.data.length > 0 ? generateTree("id", "id_parent", data.data) : [],
    }

    if (params.payload.isEngagement) {
      if (params.payload.dimensionType === "Engagement") {
        result.metric = data.measure_engagement
      } else {
        result.metric = data.metric_total
      }
    } else {
      result.metric = data.metric_total
    }

    result.levels = flatMap(result.data, (item) => item.division_level)
    result.levels = uniq(result.levels)

    yield put(getDivisionsSuccess(result))
  } catch (error) {
    yield put(getDivisionsFailed())
    returnMessage(error)
  }
}

function getDimensionsApi(params) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.measure}/dimensions`,
    params: params.params,
  })
}

function getMeasureColorRangeApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.payload.measure}/color-range`,
  })
}

export function* getDimensionsSaga(params) {
  try {
    const { data } = yield call(getDimensionsApi, params.payload)

    const result = {
      dimensions: data.data,
      showHistory: data.show_history,
      switchMoreDimensions: data.switch,
    }

    yield put(getDimensionsSuccess(result))
  } catch (error) {
    returnMessage(error, true)
  }
}

function graphicBarsApi({ idMeasure, data = {}, params = {} }) {
  
  const searchLocation = getUrlParams(location.search)
    let paramsPath = { ...searchLocation }
    
    let id_division =
      isEmpty(paramsPath.id_division) ||
      paramsPath.id_division === "undefined"
        ? null
        :(
        data.id_division_parent  ?null: `${paramsPath.id_division}`)
 // preguntar
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${idMeasure}/division/historical/comparative/new/chart?f&isExclude=${data.isExclude}`,
    data: {
      ...data,
      measure: null,
      switchBars: data.switchBars,
      isEngagement: null,
      search: data.search === "" ? null : data.search,
      id_division:id_division
    },
    params,
  })
}

export function* graphicBarsSaga(params) {
  try {
    const { data } = yield call(graphicBarsApi, params.payload)

    yield put(graphicBarsSuccess(data))
  } catch (error) {
    returnMessage(error)
  }
}

function getDivisionsWithEngagementApi(params) {
  const excludeparam = params.isExclude ? "&exclude=true" : "&exclude=false"
  const engagementParam = "&engagement=true"
  let url = `reports/measure/${params.measure}/divisions?f${excludeparam}${engagementParam}`

  if (params.isEngagement) {
    if (params.selectedType == "Engagement") {
      if (!params.dimension && (params.search == "" || params.search != "")) {
        url = `reports/measure/${params.measure}/divisions?f${excludeparam}${engagementParam}`
      }
    } else if (params.dimension) {
      url = `reports/measure/${params.measure}/dimensions/${params.dimension}/divisions?f${excludeparam}`
    }
  } else if (params.dimension) {
    url = `reports/measure/${params.measure}/dimensions/${params.dimension}/divisions?f${excludeparam}`
  }

  // Search by word
  if (params.search != "") {
    url = `${url}&filter[searchByName]=${
      typeof params.search === "undefined" ? "" : params.search
    }`
  }
  if (params.level) {
    url = `${url}&filter[level]=${params.level}`
  }

  // Making api call
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: params.params,
  })
}

export function* getDivisionsWithEngagementSaga(params) {
  try {
    const { data } = yield call(getDivisionsWithEngagementApi, params.payload)
    yield put(getDivisionWithEngagementSuccess(data))
  } catch (error) {
    returnMessage(error)
  }
}

export function* getMeasureColorRangeSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const response = yield call(getMeasureColorRangeApi, params)

    yield put(getDivisionMeasureRangeColorSuccess(response.data.data))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

function getReportMeasureInfoApi(payload) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${payload.idMeasure}/info`,
    params: { id_segment: payload.idSegment },
  })
}

export function* getMeasureSaga(action) {
  try {
    const { data: measureInfo } = yield call(
      getReportMeasureInfoApi,
      action.payload
    )
    yield put(getMeasureSuccess(measureInfo.data))
  } catch (error) {
    returnMessage(error)
  }
}

// Individual exports for testing
export default function* divisionAnalysisSaga() {
  yield takeLatest(GET_DRILLDOWN_DIVISIONS_WATCHER, getDivisionsSaga)
  yield takeLatest(GET_DIMENSIONS_WATCHER, getDimensionsSaga)
  yield takeLatest(GRAPHIC_BARS_WATCHER, graphicBarsSaga)
  yield takeLatest(
    DIVISION_WITH_ENGAGEMENT_WATCHER,
    getDivisionsWithEngagementSaga
  )
  yield takeLatest(GET_MEASURE_COLOR_RANGE_WATCHER, getMeasureColorRangeSaga)
  yield takeLatest(GET_MEASURE_WATCHER, getMeasureSaga)
  // See example in containers/HomePage/saga.js
}
